<template>
  <div :class="$store.state.page.isMobile ? 'closed-page m' : 'closed-page'">
    <div class="closed-box">
      <img class="closed-logo" src="@/assets/img/main/kai_logo_main.png" alt="KAI" />
      <h1 class="closed-title">서비스 종료 안내</h1>
      <p class="closed-desc">
        그동안 KAI를 이용해 주신 회원님께 진심으로 감사드립니다.<br />
        금일부로 모든 서비스가 종료되었습니다.
      </p>
      <div class="closed-notice">
        <p v-if="!$store.state.page.isMobile">
          문의사항은 <strong>좌측 하단 라이브챗</strong>으로 남겨주시기 바랍니다.
        </p>
        <p v-else>
          문의사항은 <strong>하단 라이브챗</strong>으로 남겨주시기 바랍니다.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  mounted() {
    this.$socket.client.on("logOut", () => {
      this.$store.dispatch("LOGOUT");
      location.reload();
    });
  },
  created() {
    window.__lc = window.__lc || {};
    window.__lc.license = 15733809;
    (function (n, t, c) {
      function i(n) {
        return e._h ? e._h.apply(null, n) : e._q.push(n);
      }
      var e = {
        _q: [],
        _h: null,
        _v: "2.0",
        on: function () {
          i(["on", c.call(arguments)]);
        },
        once: function () {
          i(["once", c.call(arguments)]);
        },
        off: function () {
          i(["off", c.call(arguments)]);
        },
        get: function () {
          if (!e._h)
            throw new Error(
              "[LiveChatWidget] You can't use getters before load."
            );
          return i(["get", c.call(arguments)]);
        },
        call: function () {
          i(["call", c.call(arguments)]);
        },
        init: function () {
          var n = t.createElement("script");
          (n.async = !0),
            (n.type = "text/javascript"),
            (n.src = "https://cdn.livechatinc.com/tracking.js"),
            (n.id = "chat"),
            t.head.appendChild(n);
        },
      };
      !n.__lc.asyncInit && e.init(),
        (n.LiveChatWidget = n.LiveChatWidget || e);
    })(window, document, [].slice);
    window.scrollTo(0, 0);
    this.visualizeChat();
  },
  methods: {
    visualizeChat() {
      (function (n, t) {
        var e = {
          init: function () {
            var n = t.getElementById("chat-widget-container");
            if (n) {
              n.style.visibility = "visible";
            }
          },
        };
        !n.__lc.asyncInit && e.init(),
          (n.LiveChatWidget = n.LiveChatWidget || e);
      })(window, document, [].slice);
    },
  },
};
</script>

<style scoped>
.closed-page {
  min-height: 100vh;
  background: #1a1d1f;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  box-sizing: border-box;
}
.closed-page.m {
  padding: 40px 16px;
}
.closed-box {
  width: 100%;
  max-width: 560px;
  text-align: center;
  background: #232728;
  border: 1px solid #2f3334;
  border-radius: 8px;
  padding: 60px 40px;
  box-sizing: border-box;
}
.closed-page.m .closed-box {
  padding: 40px 20px;
}
.closed-logo {
  max-width: 200px;
  width: 60%;
  height: auto;
  margin-bottom: 32px;
  display: inline-block;
}
.closed-page.m .closed-logo {
  max-width: 160px;
  margin-bottom: 24px;
}
.closed-title {
  color: #ffffff;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 20px 0;
  letter-spacing: -1px;
}
.closed-page.m .closed-title {
  font-size: 22px;
}
.closed-desc {
  color: #b7b7b7;
  font-size: 15px;
  line-height: 1.7;
  margin: 0 0 32px 0;
}
.closed-page.m .closed-desc {
  font-size: 13px;
}
.closed-notice {
  border-top: 1px solid #2f3334;
  padding-top: 24px;
  color: #c1c3c4;
  font-size: 14px;
  line-height: 1.6;
}
.closed-page.m .closed-notice {
  font-size: 12px;
  padding-top: 18px;
}
.closed-notice strong {
  color: #f0a020;
  font-weight: 700;
}
</style>
